import type { ReactNode } from 'react';

export interface FactRow {
    label: string;
    value: ReactNode;
}

export function RequestFacts({ rows }: { rows: FactRow[] }) {
    return (
        <dl className="divide-y divide-raro-gray-100 rounded-xl border border-raro-gray-200 bg-white text-sm">
            {rows.map(row => (
                <div key={row.label} className="grid gap-1 px-4 py-2.5 sm:grid-cols-[9rem_1fr] sm:gap-3">
                    <dt className="text-xs font-semibold uppercase tracking-wide text-raro-gray-500">{row.label}</dt>
                    <dd className="min-w-0 break-words text-raro-gray-900">{row.value}</dd>
                </div>
            ))}
        </dl>
    );
}

export function NoteBlock({ title, text }: { title: string; text: string }) {
    return (
        <div className="rounded-xl border border-raro-gray-200 bg-raro-gray-50 px-4 py-3 text-sm">
            <p className="text-xs font-semibold uppercase tracking-wide text-raro-gray-500">{title}</p>
            <p className="mt-1 whitespace-pre-wrap text-raro-gray-800">{text}</p>
        </div>
    );
}
